module.exports = __webpack_public_path__ + "media/src/img/payment/sberbank-new-logo-34ded37220326a294a4779be5899021b.svg";